// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OnboardingListHeader-module__Container__DrE1W {
    border-top-left-radius: var(--ds-l);
    border-top-right-radius: var(--ds-l);
}

.OnboardingListHeader-module__CompletedContainer__YwsiZ {
    background-color: var(--ds-color-grey-indigo-80);
}

.OnboardingListHeader-module__InnerContainer__Etuk0 {
    background-color: var(--ds-color-indigo-3);
    border-top-left-radius: var(--ds-l);
    border-top-right-radius: var(--ds-l);
}

.OnboardingListHeader-module__CompletedInnerContainer__q3ULN {
    background-color: var(--ds-color-positive-bg);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `OnboardingListHeader-module__Container__DrE1W`,
	"CompletedContainer": `OnboardingListHeader-module__CompletedContainer__YwsiZ`,
	"InnerContainer": `OnboardingListHeader-module__InnerContainer__Etuk0`,
	"CompletedInnerContainer": `OnboardingListHeader-module__CompletedInnerContainer__q3ULN`
};
export default ___CSS_LOADER_EXPORT___;
